export default {
  getTaux(duree) {
    if (duree > 0 && duree <= 10) {
      return window.taux['10ans'];
    }
    if (duree > 10 && duree <= 15) {
      return window.taux['15ans'];
    }
    if (duree > 15 && duree <= 20) {
      return window.taux['20ans'];
    }
    if (duree > 20 && duree <= 25) {
      return window.taux['25ans'];
    }
  },

  getListTaux() {
    return window.tauxSimulateurs;
  },
};
